import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LabelColumnV2 } from "../../components/DataGridV2/DataColumnsV2";

export const getAddRepairRequestBuildingColumns = ({ t,
    keyPrefix,
    i18n,
    apiRef,
}) => {
    const getOptions = getGridContextMenuList({
        filterKey: LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_FILTER[keyPrefix],
        sortKey: LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_SORT[keyPrefix],
        i18n,
        t,
        apiRef,
        mode: "client",
    })

    return [
        {
            download: true,
            print: true,
            field: "projectName",
            headerName: t("general.projectName"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.projectName}
                        cellSubMenuOptions={{ options: getOptions({ field: "projectName", isQuickFilterDisplay: Boolean(rowData.projectName) }), extraData: { fieldName: "projectName" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "buildingNoIntern",
            headerName: t("general.buildingNumber"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.buildingNoIntern}
                        cellSubMenuOptions={{ options: getOptions({ field: "buildingNoIntern", isQuickFilterDisplay: Boolean(rowData.buildingNoIntern) }), extraData: { fieldName: "buildingNoIntern" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "addressText",
            headerName: t("general.objectAddress"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.addressText}
                        cellSubMenuOptions={{ options: getOptions({ field: "addressText", isQuickFilterDisplay: Boolean(rowData.addressText) }), extraData: { fieldName: "addressText" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "postcode",
            headerName: t("general.address.postcode"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.postcode}
                        cellSubMenuOptions={{ options: getOptions({ field: "postcode", isQuickFilterDisplay: Boolean(rowData.postcode) }), extraData: { fieldName: "postcode" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "place",
            headerName: t("general.address.city"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.place}
                        cellSubMenuOptions={{ options: getOptions({ field: "place", isQuickFilterDisplay: Boolean(rowData.place) }), extraData: { fieldName: "place" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "buyerRenterName",
            headerName: t("general.buyer"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.buyerRenterName}
                        cellSubMenuOptions={{ options: getOptions({ field: "buyerRenterName", isQuickFilterDisplay: Boolean(rowData.buyerRenterName) }), extraData: { fieldName: "buyerRenterName" } }}
                        request={rowData}
                    />
                );
            },
        },
    ];

}


